export default {
    title: "Welcome back",
    "update-message": "Here’s what’s been happening since you last stopped by",
    "survey-opps": "Survey opportunities",
    "coming-soon": "Coming soon",
    "research-title": "Your personalized research opportunities",
    "research-opps": "Research opportunities",
    loading: "Loading...",
};
